module.exports = __webpack_public_path__ + "static/media/addMemberGuide2_Jap.a333cdb7.png";